export default __webpack_public_path__ + "static/media/endRound8.ea62db08.mp3";